import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BlobField from '../components/BlobField';
import api, { formatApiErrorDetail } from '../api';

/**
 * 20 — Forgot Password (matches 20-forgot-password.html).
 * Two-panel: email entry → success (check your email) confirmation.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (!email || busy) return;
    setBusy(true);
    setErr('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail) || 'Please enter a valid email.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <BlobField />
      <div className="stage">
        <div className="card" data-testid="forgot-card">
          {!sent ? (
            <>
              <Link to="/login" className="back-btn" aria-label="Back to Sign In" data-testid="forgot-back-btn" style={{ marginBottom: 18 }}>
                <svg viewBox="0 0 24 24" fill="none" width="16" height="16">
                  <path d="M15 4l-8 8 8 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </Link>
              <h1 className="heading" style={{ textAlign: 'left', fontSize: 23 }}>Reset your password</h1>
              <p className="subcopy" style={{ textAlign: 'left', margin: '6px 0 24px' }}>
                Enter the email on your account and we'll send you a link to set a new password.
              </p>
              <form onSubmit={submit}>
                <div className="field" style={{ marginBottom: 20 }}>
                  <label className="field-label"><span>Email</span></label>
                  <input
                    type="email"
                    className="field-input"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email-input"
                  />
                </div>
                {err && (
                  <p style={{ color: 'var(--error)', fontSize: 13, margin: '0 0 12px', fontWeight: 700 }} data-testid="forgot-error">
                    {err}
                  </p>
                )}
                <button type="submit" className="btn-primary" disabled={!email || busy} data-testid="forgot-submit-btn">
                  {busy ? 'Sending…' : 'Send Reset Link'}
                </button>
              </form>
              <p className="signup-note" style={{ marginTop: 16 }}>
                <Link to="/login" data-testid="forgot-back-to-signin">Back to Sign In</Link>
              </p>
            </>
          ) : (
            <div className="success-wrap" data-testid="forgot-success-panel">
              <div className="check-circle">
                <svg viewBox="0 0 24 24" fill="none" width="32" height="32">
                  <path d="M5 13l5 5L20 7" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="success-title">Check your email</div>
              <p className="success-sub">
                We've sent a password reset link to<br />
                <span className="success-email">{email}</span>
              </p>
              <p style={{ fontSize: 12, color: 'var(--text-tertiary)', fontFamily: "'JetBrains Mono', monospace", marginBottom: 16 }}>
                (During beta, the reset link is logged to the backend console.)
              </p>
              <Link to="/login" className="btn-secondary" data-testid="forgot-back-btn-success">Back to Sign In</Link>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
